<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="index"
          class="elevation-1"
          @current-items="onCurrentItems"
          ref="tableAtendimentosNoMesProfissionais"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao">
              {{ calculatePageSum() }} de {{ calculateTotalSum() }} atendimentos
            </span>
          </template>

          <!-- <template v-slot:header.no_cbo="{ header }">
            {{ header.text }}
            <span
              v-if="item.no_cbo"
              v-b-tooltip.hover
              v-bind:title="item.no_cbo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template> -->

          <template v-slot:item.nu_cbo="{ item }">
            {{ item.nu_cbo }}
            <span
              v-if="item.no_cbo"
              v-b-tooltip.hover
              v-bind:title="item.no_cbo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.qtd_total="{ item }">
            <button
              class="btn-table"
              @click="atendimentosDoProfisional(item, item.index)"
              :disabled="loadingRowIndex === item.index"
            >
              {{ item.qtd_total }}
              <b-spinner
                v-if="loadingRowIndex === item.index"
                small
                type="border"
                label="Carregando"
                variant="light"
                class="ml-2"
              />
            </button>
          </template>

          <!-- <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr></tr>
                </thead>
                <tbody>
                  <tr></tr>
                </tbody>
              </table>
            </td>
          </template> -->

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <modal-atendimentos
        :enabled="enabledModalAtendimentos"
        :atendimentos="atendimentos"
        :profissional="profissional"
        @update:enabled="enabledModalAtendimentos = $event"
      ></modal-atendimentos>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ModalAtendimentos from './ModalAtendimentos'

export default {
  name: 'TabelaCadastros',
  components: {
    ModalAtendimentos,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dataInicial: {
      type: String,
      default: '',
    },
    dataFinal: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      enabled: null,
      expanded: [],
      search: '',
      headers: [
        {
          text: 'NOME',
          align: 'start',
          filterable: true,
          sortable: true,
          value: 'no_profissional',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: true,
          sortable: true,
          value: 'nu_cbo',
        },
        {
          text: 'Manhã',
          align: 'end',
          filterable: false,
          sortable: true,
          value: 'qtd_manha',
        },
        {
          text: 'Tarde',
          align: 'end',
          filterable: false,
          sortable: true,
          value: 'qtd_tarde',
        },
        {
          text: 'Noite',
          align: 'end',
          filterable: false,
          sortable: true,
          value: 'qtd_noite',
        },
        {
          text: 'Não informado',
          align: 'end',
          filterable: false,
          value: 'qtd_nao_informado',
        },
        {
          text: 'Total',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'qtd_total',
        },
        // { text: '', value: 'data-table-expand' },
      ],
      enabledModalAtendimentos: false,
      atendimentos: [],
      profissional: null,
      loadingRowIndex: null,
      currentItems: [], //  itens da página atual (já ordenados/filtrados)
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Busca os atendimentos do profissional
     *
     * @param {Object} item
     * @param {Number} index
     */
    async atendimentosDoProfisional(item, index) {
      try {
        this.loadingRowIndex = index
        this.profissional = item

        const inicio = this.dataInicial.replaceAll('-', '')
        const fim = this.dataFinal.replaceAll('-', '')

        const response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/profissional/${item.co_dim_profissional}/${item.id_ficha}/${inicio}/${fim}`
        )
        if (response) {
          this.enabledModalAtendimentos = true
          this.atendimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingRowIndex = null
      }
    },

    onCurrentItems(items) {
      this.currentItems = items || []
    },

    /**
     * Calcula a quantidade total de uma página
     *
     * @returns {Number}
     */
    calculatePageSum() {
      return this.currentItems.reduce(
        (sum, item) => sum + Number(item.qtd_total || 0),
        0
      )
    },

    /**
     * Calcula a quantidade total de todas as páginas
     *
     * @returns {Number}
     */
    calculateTotalSum() {
      // Total independe de ordenação; só precisa considerar filtro/pesquisa
      if (this.search !== '') {
        const filtered =
          this.$refs.tableAtendimentosNoMesProfissionais?.$children[0]
            ?.filteredItems || []
        return filtered.reduce((sum, it) => sum + Number(it.qtd_total || 0), 0)
      }
      return this.indexedItems.reduce(
        (sum, it) => sum + Number(it.qtd_total || 0),
        0
      )
    },
  },
}
</script>

<style lang="scss" scoped>
#atendimentos-no-mes {
  .btn-table {
    &:disabled {
      color: #fff;
      background-color: #6c757d;
      border-color: #6c757d;
    }
  }
}
</style>
